import React from "react";

type Props = {
  id?: string; // ✅ ← これを追加！
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
  maxLength?: number;
};

const InputField = ({
  type = "text",
  placeholder,
  value,
  onChange,
  disabled = false,
  className,
  maxLength,
}: Props) => (
  <input
    type={type}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    disabled={disabled}
    className={className}
    maxLength={maxLength}
  />
);

export default InputField;
